const API_BASE = (process.env.REACT_APP_API_BASE || 'http://localhost:8000').replace(/\/$/, '');


export default function ThumbNail({ item, active, duration, offset, onClick }) {
  const bg = item.thumbnail || item.image || '';
  const distance = Math.abs(offset);
  const hidden = distance > 2;
  const scale = offset === 0 ? 1 : Math.max(1 - distance * 0.16, 0.6);
  const opacity = offset === 0 ? 1 : distance === 1 ? 0.55 : distance === 2 ? 0.25 : 0;

  return (
    <div
      className={`thumb${active ? ' active' : ''}`}
      style={{
        '--duration': `${duration}ms`,
        '--accent': item.bg_to,
        transform: `translateX(calc(${offset} * 112%)) scale(${scale})`,
        opacity,
        zIndex: 100 - distance,
        pointerEvents: hidden ? 'none' : 'auto',
      }}
      onClick={onClick}
    >
      <div
        className="thumb-bg"
        style={
          bg
            ? { backgroundImage: `url(${API_BASE + bg})` }
            : { backgroundColor: item.bg_mid }
        }
      />

    </div>
  );
}